import clsx from "clsx";
import FieldLabel from "../FieldLabel/FieldLabel";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { ICON_SIZES } from "../../helpers/constants";
import { motion } from "framer-motion";
import useMobile from "../../hooks/useMobile";
import { memo } from "react";

export type CheckBoxType = {
  onChange: (isChecked: boolean) => void;
  checked: boolean;
  label?: string;
  description?: string;
  disabled?: boolean;
  labelClass?: string;
};

const CheckBox: React.FC<CheckBoxType> = ({
  onChange,
  checked,
  label,
  description,
  disabled = false,
  labelClass = "",
}) => {
  const { isMobile } = useMobile();

  return (
    <div
      className={clsx([
        "flex",
        "flex-col",
        "gap-0",
        { "pointer-events-none": disabled },
      ])}
      onClick={() => !disabled && onChange(!checked)}
    >
      <div
        className={clsx([
          "flex",
          "flex-row",
          "w-full",
          "gap-1",
          "items-center",
          "justify-start",
          "cursor-pointer",
          "max-w-full",
        ])}
      >
        <motion.div
          key={checked ? "checked" : "unchecked"}
          initial={{ scale: checked ? 0.8 : 1, opacity: checked ? 0 : 1 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
        >
          {checked ? (
            <MdCheckBox
              size={isMobile ? ICON_SIZES.MD_LG : ICON_SIZES.LG}
              className={clsx([
                "cursor-pointer",
                "shrink-0",
                "text-blue-800",
                "dark:text-cyan-400",
              ])}
            />
          ) : (
            <MdCheckBoxOutlineBlank
              size={isMobile ? ICON_SIZES.MD_LG : ICON_SIZES.LG}
              className={clsx([
                "cursor-pointer",
                "shrink-0",
                "text-blue-800",
                "dark:text-cyan-400",
              ])}
            />
          )}
        </motion.div>
        {!!(label || description) && (
          <div className={clsx(["flex", "flex-col", "max-w-full", "truncate"])}>
            {!!label && (
              <FieldLabel
                text={label}
                className={clsx(["cursor-pointer", labelClass])}
              />
            )}
            {!!description && (
              <div
                className={clsx(["flex", "w-full", "text-sm", "md:text-sm"])}
              >
                {description}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(CheckBox);
